import { splitComponentName } from "../../../helper/splitComponent";
import DesignInfo from '@/services/Rocky/pcbInfo';
import { getDefaultPortSetupList } from "@/services/ExtractionPortsHelper";
import { USE_BALL_LIST, BALL_TYPE_NONE } from "../../../ExtractionPortsHelper/portTableHelper";
import { GAP, SPHEROID } from "../../../ExtractionPortsHelper/portTableHelper";
import { getDefaultPortsGenerateSetupList } from "../../helper/extractionPortsHelper";
import { defaultAdvanceConfig } from "./identificationHelper";
import auroraDBJson from "../../../Designs/auroraDbData";
import { strDelimited } from '@/services/helper/split';
import { UEIESWithRxTermination, UCIESNoRxTermination, UCIEA, RATE_GTS_4_8 } from "../../constants";
import { AURORA_NGSPICE } from "../../../../constants/resolution";

const signalDataTypes = ['CLK', 'DATA', 'VLD', 'TRK', 'CKRD', 'DATARD', 'VLDRD', 'DATASB', 'CKSB', 'DATASBRD', 'CKSBRD'];
const DATA = 'DATA', CLK = 'CLK', VLD = 'VLD', TRK = 'TRK', DATARD = "DATARD", CKRD = "CKRD", VLDRD = "VLDRD", DATASB = "DATASB", CKSB = "CKSB", DATASBRD = "DATASBRD", CKSBRD = "CKSBRD";

export function getCopyInterposer({ info, content, ComponentSetups, currentChannelInfo, projectType, extraction }) {
    let _content = content.interposer
    const pcbInfo = DesignInfo.getPCBInfo(info.designId);
    let { PowerNets } = _content;


    // Update Ports_generate_setup_list according to type
    let { Ports_generate_setup_list, Components, Signals, Ports_generation_setup } = _content;
    //update ports generation setup format
    if (!Ports_generate_setup_list || !Ports_generate_setup_list.length) {
        Ports_generate_setup_list = getDefaultPortsGenerateSetupList({ Ports_generation_setup, Components });
    }

    // filter referenceNets
    const allReferenceNets = PowerNets && PowerNets.length ? PowerNets.map(net => net.name) : [];
    const _referenceNets = info.referenceNets.filter(net => allReferenceNets.includes(net))
    const { port_setups, ports_generate_setup_list: setupList } = getDefaultPortSetupList({
        components: Components,
        signals: Signals,
        pcbInfo: pcbInfo,
        referenceNets: _referenceNets,
        designId: info.designId,
        ports_generate_setup_list: Ports_generate_setup_list,
        referenceZ0: info.referenceZ0,
        extractionType: extraction.channelType,
        isAuroraJson: true
    });

    _content.Ports_generate_setup_list = setupList;
    _content.ReferenceNets = _referenceNets;
    _content.Port_setups = port_setups;
    _content.Components.forEach(comp => {
        const compName = splitComponentName(comp.name);
        const filterComp = ComponentSetups.filter(it => it.name === comp.name);
        const compPortSetup = setupList.find(it => it.component === compName) || { setup: {} };
        if (filterComp && filterComp.length) {
            if ([...USE_BALL_LIST].includes(compPortSetup.setup.portType)) {
                if (compPortSetup.setup.portType === GAP) {
                    comp.gap_size = filterComp[0].gap_size || "0";
                }
                comp.ball_type = filterComp[0].ball_type;
                if (comp.ball_type === BALL_TYPE_NONE) {
                    delete comp.ball_size;
                    delete comp.ball_height;
                    delete comp.ball_material;
                } else {
                    comp.ball_size = filterComp[0].ball_size;
                    comp.ball_height = filterComp[0].ball_height;
                    comp.ball_material = filterComp[0].ball_material;
                }
                if (comp.ball_type === SPHEROID) {
                    comp.ball_mid_diameter = filterComp[0].ball_mid_diameter;
                } else {
                    delete comp.ball_mid_diameter;
                }
            } else {
                delete comp.gap_size;
                delete comp.ball_size;
                delete comp.ball_height;
                delete comp.ball_mid_diameter;
                delete comp.ball_type;
                delete comp.ball_material;
            }
        }
    })
    return { interposer: _content }
}

export function generateSignalDataType(signal) {
    const { group, signalType, displayName } = signal;
    let newGroup = group, _signalType = signalType;
    if (!group) {
        if (displayName.includes("TX") || displayName.includes("RX")) {
            const regex = /.*(TX|RX)/;
            const match = displayName.match(regex);
            if (match) {
                newGroup = match[0];
            }
        }
    }
    if (!signalType) {
        const defaultConfig = new defaultAdvanceConfig({});
        const { CLK, DATA, VLD, TRK, CKRD, DATARD, VLDRD, DATASB, CKSB, DATASBRD, CKSBRD } = defaultConfig;
        const signalTypes = [CLK, DATA, VLD, TRK, CKRD, DATARD, VLDRD, DATASB, CKSB, DATASBRD, CKSBRD];
        const typeIndexMap = new Map();
        signalTypes.forEach((typeList, index) => {
            typeList.forEach(typeItem => {
                typeIndexMap.set(typeItem, index);
            })
        })
        typeIndexMap.forEach((index, typeItem) => {
            if (displayName.includes(typeItem)) {
                _signalType = signalDataTypes[index];
            }
        })
    }
    return { signalType: _signalType, group: newGroup || "" };
}

export function findMinimalDistanceBetweenPins(pinsMap) {
    if (pinsMap.size < 2) {
        return {
            distance: Infinity,
            point1: null,
            point2: null,
        };
    }
    const pinList = Array.from(pinsMap, ([key, value]) => {
        const X = parseFloat(value.location.X);
        const Y = parseFloat(value.location.Y);
        if (isNaN(X) || isNaN(Y)) {
            console.warn(``);
        }
        return {
            key: key,
            X: X,
            Y: Y
        };
    });
    const result = getMiniDistance(pinList);
    return result;
}

function getMiniDistance(points) {
    if (points.length < 2) {
        return { distance: Infinity, p1: null, p2: null };
    }

    const distance = (p1, p2) => {
        const dx = p1.X - p2.X;
        const dy = p1.Y - p2.Y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    class Result {
        constructor(d = Infinity, p1 = null, p2 = null) {
            this.d = d;
            this.p1 = p1;
            this.p2 = p2;
        }
    }
    const Px = [...points].sort((a, b) => a.X - b.X);
    const Py = [...points].sort((a, b) => a.Y - b.Y);

    const closestPairRecurse = (PxSub, PySub) => {
        const n = PxSub.length;
        if (n <= 3) {
            let minResult = new Result();
            for (let i = 0; i < n; i++) {
                for (let j = i + 1; j < n; j++) {
                    const d = distance(PxSub[i], PxSub[j]);
                    if (d < minResult.d) {
                        minResult = new Result(d, PxSub[i], PxSub[j]);
                    }
                }
            }
            return minResult;
        }
        const mid = Math.floor(n / 2);
        const PxL = PxSub.slice(0, mid);
        const PxR = PxSub.slice(mid);
        const medianX = PxL[mid - 1].X;

        const Pyl = [];
        const Pyr = [];
        for (const p of PySub) {
            if (p.X < medianX || (p.X === medianX && Pyl.length < mid)) {
                Pyl.push(p);
            } else {
                Pyr.push(p);
            }
        }

        let minResultL = closestPairRecurse(PxL, Pyl);
        let minResultR = closestPairRecurse(PxR, Pyr);

        let minResult = (minResultL.d < minResultR.d) ? minResultL : minResultR;
        let delta = minResult.d;

        const Strip = PySub.filter(p => Math.abs(p.X - medianX) < delta);

        const stripN = Strip.length;
        for (let i = 0; i < stripN; i++) {
            for (let j = i + 1; j < stripN && (Strip[j].Y - Strip[i].Y < delta); j++) {
                const d = distance(Strip[i], Strip[j]);
                if (d < delta) {
                    delta = d;
                    minResult = new Result(d, Strip[i], Strip[j]);
                }
            }
        }

        return minResult;
    };

    const finalResult = closestPairRecurse(Px, Py);

    return {
        distance: finalResult.d,
        point1: finalResult.p1,
        point2: finalResult.p2,
    };
};

const CONVERSION_FACTORS_TO_UM = {
    'um': 1,
    'mm': 1000,
    'mils': 25.4
};

const normalizeValue = (unitString) => {
    const cleanedString = String(unitString).toLowerCase().replace(/\s/g, '');
    const match = cleanedString.match(/^([-+]?\d*\.?\d+)([a-z]+)$/);
    if (!match) return null;
    const value = parseFloat(match[1]);
    const unit = match[2];
    const factor = CONVERSION_FACTORS_TO_UM[unit];
    if (isNaN(value) || factor === undefined) return null;
    return value * factor;
};

export function compareValuesWithFactorAndUnits(ballSize, designId, comp) {
    const component = auroraDBJson.getComponent(designId, comp.name);
    const symbolName = component.symbol;
    const symbol = auroraDBJson.getSymbol(designId, symbolName);
    const filteredMap = new Map([...symbol.pins]);
    const mini = findMinimalDistanceBetweenPins(filteredMap);
    const pitchUnit = auroraDBJson.getUnit(designId);
    const newBallSize = normalizeValue(ballSize);
    const pitch = mini.distance;
    const pitchValue = `${pitch}${pitchUnit}`;
    const newPitch = normalizeValue(pitchValue);
    if (newBallSize === null || newPitch === null) {
        return null;
    }
    const portSize = newBallSize * 1.45;
    if (portSize > newPitch) {
        const updateBallSize = newPitch / 1.5;
        return updateBallSize.toFixed(0) + "um";
    } else {
        return false;
    }
};

export function getDefaultCompliance({ type, value = "0" }) {
    let list = UEIESWithRxTermination;
    let rxTermination = true;
    if (!rxTermination && type === "UCIe-S") {
        list = UCIESNoRxTermination;
    }
    if (type === "UCIe-A") {
        list = UCIEA;
        rxTermination = false;
    }
    const findCompliance = list.find(
        (item) => item.value === value
    );
    let compliance = findCompliance ? { ...findCompliance }
        : { value: "0", dataRate: RATE_GTS_4_8, tx: { R: { value: "30", unit: "Ω" }, C: { value: "0.3", unit: "pF" } }, rx: { R: { value: "50", unit: "Ω" }, C: { value: "0.3", unit: "pF" } } }
    compliance.rxTermination = rxTermination;
    compliance.hspiceConfig = { hspiceLicenses: 2 };
    compliance.ngspiceConfig = { ngspiceParallelism: 4 };
    compliance.simulate = AURORA_NGSPICE;
    return compliance;
}

export function getD2DComplianceResultList(curves, compList, channelId) {
    let obj = { list: [], show: [] };
    let list = [], show = [];

    let childInfo = {};
    for (let compInfo of compList) {
        const { name, pins } = compInfo;
        let reg = new RegExp(`(${name}_)`, 'i');
        const findCurve = curves.filter(c => {
            if (c.name.match(reg)) {
                return true
            }
            return false;
        });
        if (!findCurve || !findCurve.length) { continue }
        let children = [];

        for (let c of [...curves]) {
            const findPins = pins.find(item => c.name.match(new RegExp(`(${name}_${item.pin}_${item.signal})`, 'i')))
            if (!findPins) { continue };

            if (findPins) {
                const { pin, signal, model } = findPins;
                if (!model || !model.libraryId) { continue }
                const info = {
                    id: channelId + "::" + c.name,
                    name: c.name,
                    signal: signal,
                    compPins: `${pin}_${signal}`,
                    color: c.color,
                    type: ""
                }

                if (!childInfo[name]) { childInfo[name] = {} }
                if (!childInfo[name][signal]) { childInfo[name][signal] = [] }

                children.push(info);
                childInfo[name][signal].push(info)
            }
        }
    }

    const fileKeys = Object.keys(childInfo);
    if (fileKeys && fileKeys.length) {
        for (let fileKey of fileKeys) {
            const value = childInfo[fileKey];
            if (!value) { continue };

            const compKeys = Object.keys(value);

            let children = [];
            for (let compKey of compKeys) {
                const _children = value[compKey];
                const rowName = `${fileKey}-${compKey}`;
                children.push({
                    rowName: rowName,
                    displayName: compKey,
                    children: _children
                })
                if (!show.length) {
                    show = [fileKey, rowName]
                }
            }

            if (!show.length) {
                show.push(fileKey)
            }

            list.push({
                rowName: fileKey,
                children
            })
        }
    }

    obj = { list: list, show: show };
    return obj;
}